/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddCreatorForm } from '../models/AddCreatorForm';
import type { JsonNode } from '../models/JsonNode';
import type { UpdateCompensationRequest } from '../models/UpdateCompensationRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CreatorRestControllerService {
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static licenseCreator({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: AddCreatorForm,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/creators/{creatorId}/license',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * change creators compensation
     * update existing
     * @returns any OK
     * @throws ApiError
     */
    public static setCompensation({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        /**
         * creator compensation
         */
        requestBody: UpdateCompensationRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/creator/{creatorId}/compensation',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns JsonNode OK
     * @throws ApiError
     */
    public static listCreators(): CancelablePromise<Array<JsonNode>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/creators',
        });
    }
    /**
     * @returns JsonNode OK
     * @throws ApiError
     */
    public static getLicense({
        id,
    }: {
        id: number,
    }): CancelablePromise<JsonNode> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/creators/{id}/license',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns JsonNode OK
     * @throws ApiError
     */
    public static listCreatorsStates(): CancelablePromise<Array<JsonNode>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/creators/states',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static deleteCreator({
        creatorId,
    }: {
        creatorId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/creator/{creatorId}',
            path: {
                'creatorId': creatorId,
            },
        });
    }
}
